export const CTA_COPY = {
	primary: {
		header: {
			noneInPerson: {
				key: "primary-header-none-in-person",
				fallback: "Book your consultation",
			},
			inPerson: {
				key: "primary-header-in-person",
				fallback: "Book your consultation at {{courseTitle}}",
			},
			default: {
				key: "primary-header",
				fallback: "View Scheduling Options",
			},
			selfPaced: {
				key: "primary-header-self-paced",
				fallback: "Start your enrollment",
			},
			versions: {
				key: "primary-header-versions",
				fallback: "There are two versions of {{courseTitle}}",
			},
		},
		body: {
			inPerson: {
				key: "primary-body-in-person",
				fallback:
					"Your student will take a free placement test during the consultation at a campus.",
			},
			inPersonWithCampus: {
				key: "primary-body-in-person-with-campus",
				fallback:
					"Your student will take a free placement test during the consultation at {{campusName}}.",
			},
			noTrack: {
				key: "primary-body-no-track",
				fallback: "Choose a class that fits your schedule.",
			},
			selfPaced: {
				key: "primary-body-self-paced",
				fallback: "",
			},
			oneTrack: {
				key: "primary-body-one-track",
				fallback: "{{courseTitle}} is offered in {{trackName}}.",
			},
			multiTrack: {
				key: "primary-body-multi-track",
				fallback:
					"{{courseTitle}} is offered in {{trackNames}}. Both cover the same core curriculum.",
			},
			versions: {
				key: "primary-body-versions",
				fallback:
					"Same topics, different problems, on different schedules. Take one or both, depending on how much practice you want.",
			},
		},
		stepTag: {
			key: "step-tag",
			fallback: "FINAL STEP",
		},
	},
	tuition: {
		header: {
			key: "tuition-header",
			fallback: "{{modalityName}} TUITION",
		},
		diffPricesHeader: {
			key: "tuition-header-diff-prices",
			fallback: "{{modalityName}} TUITION STARTING AT",
		},
		label: {
			inPerson: {
				key: "tuition-label-in-person",
				fallback: "per trimester + fees",
			},
			sequential: {
				key: "tuition-label-sequential",
				fallback: "per half",
			},
			default: {
				key: "tuition-label",
				fallback: "per course",
			},
		},
		sublabel: {
			inPerson: {
				key: "tuition-sublabel-in-person",
				fallback: "{{totalPrice}} per year",
			},
			sequential: {
				key: "tuition-sublabel-sequential",
				fallback: "Full year tuition at {{totalPrice}}",
			},
			default: {
				key: "tuition-sublabel",
				fallback: "",
			},
		},
	},
	button: {
		inPerson: {
			key: "cta-button-in-person",
			fallback: "Book consultation",
		},
		noTrack: {
			key: "cta-button-no-track",
			fallback: "View schedule",
		},
		track: {
			key: "cta-button-track",
			fallback: "View {{trackName}}",
		},
		versions: {
			key: "cta-button-versions",
			fallback: "{{versionName}} Schedule",
		},
		placementTest: {
			key: "cta-button-placement-test",
			fallback: "Take Placement Test",
		},
		selfPaced: {
			key: "cta-button-self-paced",
			fallback: "Continue to enrollment",
		},
	},
	secondary: {
		header: {
			multiTrack: {
				key: "secondary-header-multi-track",
				fallback: "Explore how these classes fit your schedule.",
			},
			placementTest: {
				key: "secondary-header-placement-test",
				fallback:
					"Take a free placement test to ensure this is the right course for you.",
			},
			bookConsultation: {
				key: "secondary-header-book-consultation",
				fallback: "Need more information?",
			},
			oneTrack: {
				key: "secondary-header-one-track",
				fallback: "Explore {{trackName}} further.",
			},
		},
	},
	disabled: {
		header: {
			key: "primary-header-disabled",
			fallback: "Almost there...",
		},
		body: {
			key: "primary-body-disabled",
			/** Suggested Sanity copy; omitted from UI when the key is absent. */
			fallback:
				"Select a learning format above. Your schedule and pricing will show up right here.",
		},
		tuitionHeader: {
			key: "tuition-header-disabled",
			fallback: "TUITION",
		},
		tuitionPlaceholder: {
			key: "tuition-placeholder-disabled",
			fallback: "Appears with selections",
		},
		button: {
			key: "cta-button-disabled",
			fallback: "View schedule",
		},
	},
	/**
	 * Beast Academy has no course offerings, so its CTA copy is fixed here and
	 * its price comes from the modality's manual price fields in Sanity.
	 * There is no body key — the subtitle is intentionally blank.
	 */
	beastAcademy: {
		header: {
			key: "primary-header-beast-academy",
			fallback: "View Subscriptions",
		},
		tuitionHeader: {
			key: "tuition-header-beast-academy",
			fallback: "BEAST ACADEMY ONLINE STARTING AT",
		},
		button: {
			key: "cta-button-beast-academy",
			fallback: "Compare options",
		},
	},
} as const;
